import React from 'react';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import * as API from 'ff/debrief/features/TracklogApi';
import { LinkToHome, LinkToShared } from 'ff/debrief/router';

interface Props {
    currentTab: number;
}

const SidebarTabs: React.FC<Props> = props => {
    const tracklogsQuery = API.useGetAllTracklogsQuery({ page: 0 });
    const sharedTracklogsQuery = API.useGetAllSharedTracklogsQuery();
    const ownListIsEmpty = tracklogsQuery.data?.totalTracklogs === 0;
    const sharedListIsEmpty = sharedTracklogsQuery.data?.length === 0;
    if (
        tracklogsQuery.isLoading ||
        tracklogsQuery.isError ||
        sharedListIsEmpty
    ) {
        return null;
    } else if (tracklogsQuery.isSuccess) {
        return (
            <Tabs value={props.currentTab} variant="fullWidth">
                <Tab
                    component={LinkToHome}
                    label="My Track Logs"
                    disabled={ownListIsEmpty}
                    value={MINE}
                />
                <Tab
                    component={LinkToShared}
                    label="Shared With Me"
                    value={SHARED}
                />
            </Tabs>
        );
    }
};

export const MINE = 1;
export const SHARED = 2;

export default SidebarTabs;
